import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setModal } from 'redux/index';
import Slider from 'react-slick';
import DeleteForever from '@mui/icons-material/DeleteForever';
import { Icon } from '@mui/material';
import Close from '@mui/icons-material/Close';
import { CarouselImage, TransparentButton } from 'components';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from '../addImage.module.css';

const LazyCarousel = (props) => {
	const { photos, initialSlide, setModal, setSrc, removeFile } = props;
	const [currentSlide, setCurrentSlide] = useState(initialSlide || 0);
	const settings = {
		className: styles.carouselSlider,
		dots: true,
		lazyLoad: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		initialSlide: initialSlide || 0,
		afterChange: (cur) => {
			setCurrentSlide(cur);
		},
	};

	const [slides, setSlides] = useState(null);

	useEffect(() => {
		let photoArray = photos.map((val, i) => {
			return <CarouselImage key={i} photo={val} setDownloadSrc={setSrc} />;
		});
		setSlides(photoArray);
	}, [photos, setSrc]);

	useEffect(() => {
		if (slides && !slides.length) {
			setModal(false);
		}
	}, [setModal, slides]);

	return (
		<div className={styles.carouselRoot}>
			{removeFile && (
				<TransparentButton
					onClick={() => {
						removeFile(currentSlide);
					}}
					style={{ color: 'white' }}
					className={styles.carouselDelete}>
					<Icon>
						<DeleteForever />
					</Icon>
				</TransparentButton>
			)}
			<TransparentButton
				onClick={() => {
					setModal(false);
				}}
				style={{ color: 'white' }}
				className={styles.carouselClose}>
				<Icon>
					<Close />
				</Icon>
			</TransparentButton>
			{slides && <Slider {...settings}>{slides}</Slider>}
		</div>
	);
};

export default connect(null, { setModal })(LazyCarousel);
